<app-menu>
  <div class="desktop">
    <div class="header">
      <app-titulo text="Apontamento de horas"></app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Adicionar ponto"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigatePonto()"
          *ngIf="permission === 1"
        ></app-botao>
        <app-botao
          type="secundario"
          text="Extração de relatório"
          width="100%"
          icon="assets/images/download-icon.svg"
          (click)="extracaoRelatorio()"
        ></app-botao>
        <app-botao
          type="secundario"
          text="Baixar lista presença"
          width="100%"
          icon="assets/images/download-icon.svg"
          (click)="apontamentoDiario()"
        ></app-botao>
        <app-botao
        type="secundario"
        text="Upload da lista de presença"
        width="100%"
        icon="assets/images/download-icon.svg"
        (click)="uploadLista()"
      ></app-botao>
      </div>
    </div>
    <div class="table-header">
      <h1 class="table-title">Apontamentos</h1>
      <div class="table-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxPesquisar"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          type="select"
          name="situacao"
          placeholder="Situação"
          [selectData]="situacaoOptions"
          [(ngModel)]="pesquisaParams.Situacao"
          (ngModelChange)="getApontamentos()"
        ></app-input>
        <app-input
          type="date"
          placeholder="Data inicial"
          [(ngModel)]="pesquisaParams.DtInicio"
          (blurEvent)="getApontamentos()"
        ></app-input>
        <app-input
          type="date"
          placeholder="Data final"
          [(ngModel)]="pesquisaParams.DtFim"
          (blurEvent)="getApontamentos()"
        ></app-input>
      </div>
    </div>
    <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
    <div class="paginacao">
      <app-paginacao
        [pages]="this.pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
    </div>
  </div>
  <div class="mobile">
    <app-titulo text="Apontamento de horas"></app-titulo>
    <div class="apontamentos">
      <div class="menu-mobile">
        <app-titulo text="Apontamentos"></app-titulo>
        <img
          *ngIf="!expandirCardsMobile"
          (click)="expandirCardsMobile = !expandirCardsMobile"
          src="assets/images/arrow-down.svg"
          class="expandir-icon"
        />
        <img
          *ngIf="expandirCardsMobile"
          (click)="expandirCardsMobile = !expandirCardsMobile"
          src="assets/images/arrow-up.svg"
          class="expandir-icon"
        />
      </div>
      <div class="table-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxPesquisar"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          type="select"
          name="situacao"
          placeholder="Situação"
          [selectData]="situacaoOptions"
          [(ngModel)]="pesquisaParams.Situacao"
          (ngModelChange)="getApontamentos()"
        ></app-input>
        <app-input
          type="date"
          placeholder="Data inicial"
          [(ngModel)]="pesquisaParams.DtInicio"
          (blurEvent)="getApontamentos()"
          *ngIf="expandirCardsMobile"
        ></app-input>
        <app-input
          type="date"
          placeholder="Data final"
          [(ngModel)]="pesquisaParams.DtFim"
          (blurEvent)="getApontamentos()"
          *ngIf="expandirCardsMobile"
        ></app-input>
      </div>
      <div class="mobile-buttons" *ngIf="expandirCardsMobile">
        <app-botao
          type="primario"
          text="Adicionar ponto"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigatePonto()"
        ></app-botao>
      </div>
      <app-card-mobile
        [data]="tableData"
        [rows]="rowsMobile"
        [expand]="expandirCardsMobile"
      >
      </app-card-mobile>
      <app-paginacao
        [pages]="this.pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
      <app-botao
        type="secundario"
        width="100%"
        text="Extração de relatório"
        icon="assets/images/download-icon.svg"
        (click)="extracaoRelatorio()"
      ></app-botao>
    </div>
  </div>
</app-menu>

<app-modal-horarios-layout
  *ngIf="visibleHorariosApontados"
  [pessoaData]="pessoaData"
  (inputClose)="verHorarios()"
></app-modal-horarios-layout>
<app-modal-extracao-relatorio-layout
  *ngIf="visibleExtracaoRelatorio"
  (inputClose)="extracaoRelatorio()"
></app-modal-extracao-relatorio-layout>
<app-modal-upload-lista-layout
  *ngIf="visibleUploadLista"
  (inputClose)="uploadLista()"
></app-modal-upload-lista-layout>
<app-loader *ngIf="loader" />
